import React, { useState, useEffect } from 'react';
import { Card, Row, Col, Form } from 'react-bootstrap';
import { ToastContainer, toast } from 'react-toastify';
import axios from "axios";
import DataTable from 'react-data-table-component';
import Header from '../../components/layout/header/header';
import LeftNav from '../../components/layout/leftNav/leftNav';
import { Tooltip } from "@mui/material";
import { fetchDataRead } from "../../Utility";
import loading from "../../assets/images/common/loading.gif";
import AppDataGrid from '../../components/common/AppDataGrid';
const PromotedStudents = () => {
    const baseUrl = process.env.REACT_APP_API_BASE_URL;
    const userData = sessionStorage.getItem('user');
    const userObj = userData ? JSON.parse(userData) : {};
    const [isLoading, setIsLoading] = useState(false);
    const readOnlyRoles = ["Class Teacher", "Teacher", "Class Incharge"];
    const canSubmit = !readOnlyRoles.includes(userObj.role_name?.trim());

    const [classes, setClasses] = useState([]);
    const [sections, setSections] = useState([]);
    const [targetSections, setTargetSections] = useState([]);
    const [filteredSections, setFilteredSections] = useState([]);
    const [students, setStudents] = useState([]);
    const [promoteToSections, setPromoteToSections] = useState([]);
    const [filter, setFilter] = useState({ class_id: "", section_id: "" });
    const [promoteTo, setPromoteTo] = useState({ new_class_id: "", new_section_id: "" });
    // Academic year dropdown state
    const [form, setForm] = useState({ academic_year_id: "" });
    const [academic, setAcademic] = useState([]);

    const [globalPromotionStatus, setGlobalPromotionStatus] = useState("");
    const [globalContinueStatus, setGlobalContinueStatus] = useState("");

    useEffect(() => {
        fetchDataRead("/classes/", setClasses, userObj.school_id);
        fetchDataRead("/Sections/", setSections, userObj.school_id,userObj.academic_year_id);
        // Fetch academic years for promotion target
        fetchDataRead("/AcademicYear/", setAcademic, userObj.school_id);
    }, []);

    useEffect(() => {
        if (filter.class_id && filter.section_id) {
            handleFilterSubmit();
        }
    }, [filter.class_id, filter.section_id]);

    useEffect(() => {
        if (promoteTo.new_class_id && Array.isArray(targetSections)) {
            const classId = parseInt(promoteTo.new_class_id);
            const updatedSections = targetSections.filter(s => s.class_id === classId);
            setPromoteToSections(updatedSections);
            setPromoteTo(prev => ({ ...prev, new_section_id: "" }));
        }
    }, [promoteTo.new_class_id, targetSections]);

    // const handleSave = async () => {
    //     const validStudents = students.filter(s =>
    //         s.promotion_status && s.continue_status && s.new_section_id
    //     );

    //     if (validStudents.length === 0) {
    //         toast.warning("No valid student entries to save.");
    //         return;
    //     }

    //     const payload = {
    //         action: "CREATE",
    //         promote_id: validStudents.map(() => 0),
    //         student_id: validStudents.map(s => s.student_id),
    //        old_academic_year_id: validStudents.map(() => userObj.academic_year_id),
    //         new_class_id: validStudents.map(s => parseInt(s.new_class_id)),  // ✅ per-student
    //         new_section_id: validStudents.map(s => parseInt(s.new_section_id)),
    //         pass_or_promoted: validStudents.map(s =>
    //             s.promotion_status === "pass" ? "PA" : "PR"
    //         ),
    //         continue_or_leaving: validStudents.map(s =>
    //             s.continue_status === "continue" ? "C" : "L"
    //         ),
    //         school_id: validStudents.map(s => s.school_id || userObj.school_id),
    //         createdby: validStudents.map(() => userObj.email || "system"),
    //         lastmodifiedby: validStudents.map(() => userObj.email || "system")
    //     };


    //     try {
    //         const response = await axios.post(`${baseUrl}/PromoteStudents/`, payload, {
    //             headers: { 'Content-Type': 'application/json' }
    //         });

    //         const { message, errors = [] } = response.data;

    //         if (errors.length > 0) {
    //             toast.error(message || "Some students failed to promote.");
    //             errors.forEach(err => {
    //                 toast.error(`ID ${err.student_id}: ${err.error}`);
    //             });

    //             const errorList = errors.map(err =>
    //                 `ID ${err.student_id}: ${err.error}`
    //             ).join("\n");

    //             alert("Some promotions failed:\n\n" + errorList);
    //         } else {
    //             toast.success(message || "All students promoted successfully!");
    //         }

    //         handleFilterSubmit(); // refresh students list
    //     } catch (error) {
    //         const { response } = error;

    //         if (!response) {
    //             toast.error("Server not reachable.");
    //             return;
    //         }

    //         const { status, data } = response;

    //         if (status === 401) {
    //             toast.error("Academic year mapping error: " + (data.message || ""));
    //         } else if (status === 402) {
    //             toast.error("Student already promoted: " + (data.message || ""));
    //         } else if (status === 500) {
    //             toast.error("Server error: " + (data.message || "Try again later."));
    //         } else if (status === 400 && data?.errors) {
    //             data.errors.forEach(err => {
    //                 toast.error(`ID ${err.student_id}: ${err.error}`);
    //             });

    //             const errorList = data.errors.map(err =>
    //                 `ID ${err.student_id}: ${err.error}`
    //             ).join("\n");

    //             alert("Some promotions failed:\n\n" + errorList);
    //         } else {
    //             toast.error(data.message || "Unexpected error occurred.");
    //         }
    //     }
    // };

    const handleSave = async () => {
        const validStudents = students.filter(s =>
            s.promotion_status && s.continue_status && s.new_section_id && s.new_class_id
        );

        if (validStudents.length === 0) {
            toast.warning("No valid student entries to save.");
            return;


        }

        const fromClassName = classes.find(c => c.class_id === parseInt(filter.class_id))?.class_name || "Current Class";
        const toClassName = classes.find(c => c.class_id === parseInt(promoteTo.new_class_id))?.class_name || "Target Class";

        const confirmMsg = `Are you sure you want to promote students from ${fromClassName} to ${toClassName}?`;
        const userConfirmed = window.confirm(confirmMsg);
        if (!userConfirmed) return;

        const payload = {
            action: "CREATE",
            promote_id: validStudents.map(() => 0),
            student_id: validStudents.map(s => s.student_id),
            old_academic_year_id: validStudents.map(() => userObj.academic_year_id), // ✅ Set same value per student
            new_class_id: validStudents.map(s => parseInt(s.new_class_id)),           // ✅ Must exist per student
            new_section_id: validStudents.map(s => parseInt(s.new_section_id)),
            pass_or_promoted: validStudents.map(s =>
                s.promotion_status === "pass" ? "PA" : "PR"
            ),
            continue_or_leaving: validStudents.map(s =>
                s.continue_status === "continue" ? "C" : "L"
            ),
            school_id: validStudents.map(() => userObj.school_id),
            createdby: validStudents.map(() => userObj.email || "system"),
            lastmodifiedby: validStudents.map(() => userObj.email || "system")
        };

        try {
            const response = await axios.post(`${baseUrl}/PromoteStudents/`, payload, {
                headers: { 'Content-Type': 'application/json' }
            });

            const { message, data = [], errors = [] } = response.data;

            if (errors.length > 0) {
                toast.error(message || "Some students failed to promote.");
                errors.forEach(err => {
                    toast.error(`ID ${err.student_id}: ${err.error}`);
                });

                const errorList = errors.map(err =>
                    `ID ${err.student_id}: ${err.error}`
                ).join("\n");

                alert("Some promotions failed:\n\n" + errorList);
            } else {
                toast.success(message || "All students promoted successfully!");
            }

            handleFilterSubmit(); // Refresh UI
        } catch (error) {
            const { response } = error;

            if (!response) {
                toast.error("Server not reachable.");
                return;
            }

            const { status, data } = response;

            if (status === 409) {
                toast.error("Academic year mapping error: " + (data?.detail || ""));
            } else if (status === 404) {
                toast.error("Next academic year not found: " + (data?.detail || ""));
            } else if (status === 405) {
                toast.error("Student already promoted" + (data?.detail || ""));
            } else if (status === 500) {
                toast.error("Server error: " + (data?.detail || "Try again later."));
            } else if (status === 400 && data?.errors) {
                data.errors.forEach(err => {
                    toast.error(`ID ${err.student_id}: ${err.error}`);
                });

                const errorList = data.errors.map(err =>
                    `ID ${err.student_id}: ${err.error}`
                ).join("\n");

                alert("Some promotions failed:\n\n" + errorList);
            } else {
                toast.error(data?.detail || "Unexpected error occurred.");
            }
        }
    };


    const handleFilterChange = (e) => {
    // existing logic unchanged
        const { name, value } = e.target;

        if (name === "class_id") {
            const selectedClassId = parseInt(value, 10);

            // ✅ Set filter.class_id
            setFilter(prev => ({ ...prev, class_id: selectedClassId, section_id: "" }));

            // ✅ Filter corresponding sections
            if (Array.isArray(sections)) {
                const updatedSections = sections.filter(
                    section => Number(section?.class_id) === selectedClassId
                );
                setFilteredSections(updatedSections);
            } else {
                setFilteredSections([]);
            }
        } else {
            setFilter(prev => ({ ...prev, [name]: value }));
        }
    };


    const handleAcademicYearChange = (e) => {
        const { value } = e.target;
        setForm(prev => ({ ...prev, academic_year_id: value }));

        if (value) {
            fetchDataRead("/Sections/", setTargetSections, userObj.school_id, value);
        } else {
            setTargetSections([]);
        }

        // Reset promoteTo class and section when Academic Year changes
        setPromoteTo(prev => ({ ...prev, new_class_id: "", new_section_id: "" }));
        setPromoteToSections([]);

        // Reset students target class and section
        setStudents(prev =>
            prev.map(s => ({
                ...s,
                new_class_id: "",
                new_section_id: "",
                has_custom_section: false
            }))
        );
    };

    // const handleFilterSubmit = async () => {
    //     setIsLoading(true);
    //     try {
    //         const response = await axios.post(baseUrl + "/students/", {
    //             action: "FILTER",
    //             school_id: userObj.school_id,
    //             class_id: filter.class_id,
    //             section_id: filter.section_id,
    //             academic_year_id: userObj.academic_year_id
    //         });
    //         const data = response.data || [];
    //         const enriched = data.map(s => ({
    //             ...s,
    //             promotion_status: "",
    //             continue_status: "",
    //             new_section_id: promoteTo.new_section_id || "",// initialize per student,
    //             has_custom_section: false,
    //         }));

    //         setStudents(enriched);
    //     } catch (error) {
    //         console.error("Error fetching students:", error);
    //         toast.error("Failed to fetch students.");
    //     }
    //     finally {
    //         setIsLoading(false);
    //     }
    // };
    const handleFilterSubmit = async () => {
        setIsLoading(true);
        try {
            // Step 1: Fetch students
            const studentsResponse = await axios.post(baseUrl + "/students/", {
                action: "FILTER",
                school_id: userObj.school_id,
                class_id: filter.class_id,
                section_id: filter.section_id,
                academic_year_id: userObj.academic_year_id,
                status: 'Active'
            });
            const students = studentsResponse.data || [];

            // Step 2: Fetch promoted students mapped
            const promotedResponse = await axios.post(baseUrl + "/GetPromotedStudents/", {
                action: "FILTER",
                school_id: userObj.school_id,
                old_class_id: filter.class_id,
                old_section_id: filter.section_id,
                old_academic_year_id: userObj.academic_year_id
            });
            const promotedMap = (promotedResponse.data || []).reduce((acc, item) => {
                acc[item.student_id] = item;
                return acc;
            }, {});

            // Step 3: Merge data into student list
            const enriched = students.map(s => {
                const promoted = promotedMap[s.student_id];
                return {
                    ...s,
                    promotion_status: promoted
                        ? (promoted.pass_or_promoted === "Promoted" ? "promote" : "pass")
                        : "",
                    continue_status: promoted
                        ? (promoted.continue_or_leaving === "Continue" ? "continue" : "leaving")
                        : "",
                    new_section_id: promoted?.new_section_id ? String(promoted.new_section_id) : promoteTo.new_section_id || "",

                    has_custom_section: !!promoted,
                    new_class_id: promoted?.new_class_id || promoteTo.new_class_id || ""
                };
            });

            setStudents(enriched);
        } catch (error) {
            console.error("Error fetching students:", error);
            toast.error("Failed to fetch students.");
        } finally {
            setIsLoading(false);
        }
    };


    const updateStudent = (studentId, updates) => {
        setStudents(prev =>
            prev.map(s => s.student_id === studentId ? { ...s, ...updates } : s)
        );
    };

    const handleGlobalOption = (type) => {
        // Apply the selected promotion type only to rows without an explicit custom selection.
        setGlobalPromotionStatus(type);
        setStudents(prev =>
            prev.map(s =>
                s.has_custom_promotion ? s : { ...s, promotion_status: type }
            )
        );
    };

    const handleGlobalStatus = (type) => {
        // Apply continue status globally only to rows without an explicit custom selection.
        setGlobalContinueStatus(type);
        setStudents(prev =>
            prev.map(s =>
                s.has_custom_continue ? s : { ...s, continue_status: type }
            )
        );
    };

   const columns = [
  {
    field: 'roll_no',
    headerName: 'Roll No',
    flex: 0.8,
    headerAlign: 'center',
    align: 'center',
    sortable: true,
    valueGetter: (params) => (params.row.isEmptyRow ? '' : params.row.roll_no),
    renderCell: (params) =>
      params.row.isEmptyRow ? '' : (
        <Tooltip title={params.value}><span>{params.value}</span></Tooltip>
      ),
  },
  {
    field: 'student_name',
    headerName: 'Student Name',
    flex: 1.4,
    headerAlign: 'center',
    align: 'center',
    sortable: true,
    valueGetter: (params) => {
      if (params.row.isEmptyRow) return '';
      const fn = params.row.student_first_name || '';
      const ln = params.row.student_last_name || '';
      return `${fn} ${ln}`.trim();
    },
    renderCell: (params) =>
      params.row.isEmptyRow ? '' : (
        <Tooltip title={params.value}><span>{params.value}</span></Tooltip>
      ),
  },
  {
    field: 'class_name',
    headerName: 'Class',
    flex: 1,
    headerAlign: 'center',
    align: 'center',
    sortable: true,
    valueGetter: (params) => (params.row.isEmptyRow ? '' : params.row.class_name),
    renderCell: (params) =>
      params.row.isEmptyRow ? '' : (
        <Tooltip title={params.value}><span>{params.value}</span></Tooltip>
      ),
  },
  {
    field: 'section_name',
    headerName: 'Section',
    flex: 1,
    headerAlign: 'center',
    align: 'center',
    sortable: true,
    valueGetter: (params) => (params.row.isEmptyRow ? 'No Records Found' : params.row.section_name),
    renderCell: (params) =>
      params.row.isEmptyRow ? (
        <div style={{ width: '100%', textAlign: 'center', color: 'red', fontWeight: 'bold' }}>
          No Records Found
        </div>
      ) : (
        <Tooltip title={params.value}><span>{params.value}</span></Tooltip>
      ),
  },
  {
    field: 'promotion_status',
    headerName: 'Passed/Promoted',
    flex: 1.6,
    headerAlign: 'center',
    align: 'center',
    sortable: false,
    renderCell: (params) =>
      params.row.isEmptyRow ? '' : (
        <div>
          <Form.Check
            type="radio"
            inline
            label="None"
            name={`promotion_${params.row.student_id}`}
            checked={params.row.promotion_status === ''}
            onChange={() => {
              updateStudent(params.row.student_id, { promotion_status: '', has_custom_promotion: true });
              setGlobalPromotionStatus('');
            }}
          />
          <Form.Check
            type="radio"
            inline
            label="Pass"
            name={`promotion_${params.row.student_id}`}
            checked={params.row.promotion_status === 'pass'}
            onChange={() => {
              updateStudent(params.row.student_id, { promotion_status: 'pass', has_custom_promotion: true });
              setGlobalPromotionStatus('');
            }}
          />
          <Form.Check
            type="radio"
            inline
            label="Promoted"
            name={`promotion_${params.row.student_id}`}
            checked={params.row.promotion_status === 'promote'}
            onChange={() => {
              updateStudent(params.row.student_id, { promotion_status: 'promote', has_custom_promotion: true });
              setGlobalPromotionStatus('');
            }}
          />
        </div>
      ),
  },
  {
    field: 'continue_status',
    headerName: 'Is Continue?',
    flex: 1.6,
    headerAlign: 'center',
    align: 'center',
    sortable: false,
    renderCell: (params) =>
      params.row.isEmptyRow ? '' : (
        <div>
          <Form.Check
            type="radio"
            inline
            label="None"
            name={`continue_${params.row.student_id}`}
            checked={params.row.continue_status === ''}
            onChange={() => {
              updateStudent(params.row.student_id, { continue_status: '', has_custom_continue: true });
              setGlobalContinueStatus('');
            }}
          />
          <Form.Check
            type="radio"
            inline
            label="Continue"
            name={`continue_${params.row.student_id}`}
            checked={params.row.continue_status === 'continue'}
            onChange={() => {
              updateStudent(params.row.student_id, { continue_status: 'continue', has_custom_continue: true });
              setGlobalContinueStatus('');
            }}
          />
          <Form.Check
            type="radio"
            inline
            label="Leaving"
            name={`continue_${params.row.student_id}`}
            checked={params.row.continue_status === 'leaving'}
            onChange={() => {
              updateStudent(params.row.student_id, { continue_status: 'leaving', has_custom_continue: true });
              setGlobalContinueStatus('');
            }}
          />
        </div>
      ),
  },
  {
    field: 'new_class_name',
    headerName: 'New Class',
    flex: 1,
    headerAlign: 'center',
    align: 'center',
    sortable: false,
    valueGetter: (params) => {
      if (params.row.isEmptyRow) return '';
      const promotedClass = classes.find(
        (c) => c.class_id === parseInt(params.row.new_class_id)
      );
      const globalClass = classes.find(
        (c) => c.class_id === parseInt(promoteTo?.new_class_id)
      );
      return promotedClass ? promotedClass.class_name : (globalClass ? globalClass.class_name : '');
    },
    renderCell: (params) =>
      params.row.isEmptyRow ? '' : (
        <Tooltip title={params.value}><span>{params.value}</span></Tooltip>
      ),
  },
  {
    field: 'new_section_id',
    headerName: 'New Section',
    flex: 1.2,
    headerAlign: 'center',
    align: 'center',
    sortable: false,
    renderCell: (params) => {
      if (params.row.isEmptyRow) return '';

      const effectiveClassId = params.row.new_class_id || promoteTo?.new_class_id;
      const availableSections = targetSections.filter(
        (s) => parseInt(s.class_id) === parseInt(effectiveClassId)
      );
      const effectiveSectionId = params.row.new_section_id || '';

      return (
        <Form.Select
          size="sm"
          value={String(effectiveSectionId)}
          onChange={(e) => {
            updateStudent(params.row.student_id, {
              new_section_id: e.target.value,
              has_custom_section: true,
            });
          }}
          disabled={!effectiveClassId}
        >
          <option value="" disabled hidden>Select Section</option>
          {availableSections
            .filter((s) => s.is_active === 'Active')
            .map((s) => (
              <option key={s.section_id} value={String(s.section_id)}>
                {s.section_name}
              </option>
            ))}
        </Form.Select>
      );
    },
  },
];



    return (
            
                <div className='pageBody'>
                    <ToastContainer />
                    <div className="commonDataTableHead">
                        <div className="d-flex justify-content-between align-items-center w-100">
                            <h6 className="commonTableTitle">Promote Students</h6>
                        </div>
                    </div>

                    <div className="d-flex align-items-center justify-content-start flex-wrap gap-2 mb-2 p-2 rounded bg-white border shadow-sm w-100" style={{ fontSize: "13px" }}>
                        
                        {/* Source Selection Group */}
                        <div className="d-flex align-items-center gap-2 border-end pe-3">
                            <span className="text-muted fw-bold me-1">From:</span>
                            <Form.Select name="class_id" value={filter.class_id} onChange={handleFilterChange} required size="sm" style={{ width: "120px" }}>
                                <option value="" disabled hidden>Select Class</option>
                                {classes.filter(c => c.is_active === "Active").map(c => (
                                    <option key={c.class_id} value={c.class_id}>{c.class_name}</option>
                                ))}
                            </Form.Select>

                            <Form.Select name="section_id" value={filter.section_id} onChange={handleFilterChange} disabled={!filter.class_id} required size="sm" style={{ width: "120px" }}>
                                <option value="" disabled hidden>Select Section</option>
                                {filteredSections.filter(s => s.is_active === "Active").map(s => (
                                    <option key={s.section_id} value={s.section_id}>{s.section_name}</option>
                                ))}
                            </Form.Select>
                        </div>

                        {/* Separator / Direction Badge */}
                        <div className="d-flex align-items-center px-1 text-primary fw-bold" style={{ fontSize: "13px" }}>
                            Promote To <i className="bi bi-chevron-right ms-1"></i>
                        </div>

                        {/* Target Selection Group */}
                        <div className="d-flex align-items-center gap-2 border-end pe-3">
                            <Form.Select
                                id="academic_year_id"
                                value={form.academic_year_id}
                                onChange={handleAcademicYearChange}
                                size="sm"
                                style={{ width: "140px" }}
                            >
                                <option value="" disabled hidden>Academic Year</option>
                                {(academic || []).map((year) => (
                                    <option key={year.academic_year_id} value={year.academic_year_id}>
                                        {year.academic_year_name}
                                    </option>
                                ))}
                            </Form.Select>

                            <Form.Select
                                value={promoteTo.new_class_id}
                                onChange={(e) => {
                                    const classId = e.target.value;
                                    setPromoteTo(prev => ({ ...prev, new_class_id: classId, new_section_id: "" }));
                                    const classIdInt = parseInt(classId);
                                    const updatedSections = (targetSections||[]).filter(s => s.class_id === classIdInt);
                                    setPromoteToSections(updatedSections);
                                    setStudents(prev =>
                                        prev.map(s =>
                                            s.has_custom_section
                                                ? s
                                                : { ...s, new_class_id: classId, new_section_id: "" }
                                        )
                                    );
                                }}
                                disabled={!form.academic_year_id}
                                size="sm"
                                style={{ width: "120px" }}
                            >
                                <option value="" disabled hidden>Select Class</option>
                                {classes.map(c => (
                                    <option key={c.class_id} value={c.class_id}>{c.class_name}</option>
                                ))}
                            </Form.Select>

                            <Form.Select
                                value={promoteTo.new_section_id}
                                onChange={(e) => {
                                    const sectionId = e.target.value;
                                    setPromoteTo(prev => ({ ...prev, new_section_id: sectionId }));
                                    setStudents(prev =>
                                        prev.map(s =>
                                            s.has_custom_section ? s : { ...s, new_section_id: sectionId }
                                        )
                                    );
                                }}
                                disabled={!form.academic_year_id || !promoteTo.new_class_id}
                                size="sm"
                                style={{ width: "120px" }}
                            >
                                <option value="" disabled hidden>Select Section</option>
                                {promoteToSections
                                    .filter(s => s.is_active === "Active")
                                    .map(s => (
                                        <option key={s.section_id} value={s.section_id}>
                                            {s.section_name}
                                        </option>
                                    ))}
                            </Form.Select>
                        </div>

                        {/* Bulk Action Controls */}
                        <div className="d-flex align-items-center gap-3">
                            {/* Promotion Radio Group */}
                            <div className="d-flex align-items-center gap-2 border-end pe-3" style={{ borderRightColor: "#eee" }}>
                                <Form.Check
                                    type="radio"
                                    label="Pass All"
                                    name="promotion"
                                    checked={globalPromotionStatus === "pass"}
                                    onChange={() => handleGlobalOption("pass")}
                                    inline
                                    style={{ margin: 0 }}
                                />
                                <Form.Check
                                    type="radio"
                                    label="Promote All"
                                    name="promotion"
                                    checked={globalPromotionStatus === "promote"}
                                    onChange={() => handleGlobalOption("promote")}
                                    inline
                                    style={{ margin: 0 }}
                                />
                            </div>

                            {/* Status Radio Group */}
                            <div className="d-flex align-items-center gap-2">
                                <Form.Check
                                    type="radio"
                                    label="None"
                                    name="status"
                                    checked={globalContinueStatus === ""}
                                    onChange={() => handleGlobalStatus("")}
                                    inline
                                    style={{ margin: 0 }}
                                />
                                <Form.Check
                                    type="radio"
                                    label="Continue"
                                    name="status"
                                    checked={globalContinueStatus === "continue"}
                                    onChange={() => handleGlobalStatus("continue")}
                                    inline
                                    style={{ margin: 0 }}
                                />
                                <Form.Check
                                    type="radio"
                                    label="Leaving"
                                    name="status"
                                    checked={globalContinueStatus === "leaving"}
                                    onChange={() => handleGlobalStatus("leaving")}
                                    inline
                                    style={{ margin: 0 }}
                                />
                            </div>
                        </div>
                    </div>

                    {/* Action Row for Save button below */}
                    <div className="d-flex justify-content-end mb-3 pe-1">
                        {canSubmit && (
                            <button
                                className="btn btn-primary px-4 fw-bold shadow-sm"
                                style={{ fontSize: "13px", height: "32px", borderRadius: "4px" }}
                                onClick={handleSave}
                            >
                                Save
                            </button>
                        )}
                    </div>

                    <div className="commonTable height100">
                        <div className="tableBody">
                            {isLoading ? (
                                <div className="loadingContainer">
                                    <img src={loading} alt="Loading..." className="loadingGif" />
                                </div>
                            ) : (
                                 <AppDataGrid
                            rows={students.length ? students : []}
                            columns={columns}
                            getRowId={(row) => row.student_id}
                            pageSizeOptions={[10, 20, 50]}      // Dropdown options
                            showToolbar={false}
                            pagination
                            density="compact"
                            maxHeight={550}
                        />
                            )}
                        </div>
                    </div>

                </div>
    );
};

export default PromotedStudents;
